export default "__VITE_ASSET__e54979ed__"